document.querySelectorAll('.button--filter').forEach(e=> {
    
    e.addEventListener('click', function() {
        const handle = e.dataset.handle

        document.querySelectorAll('.button--filter').forEach(filt=> {
            filt.classList.remove('active')
        })

        this.classList.add('active')

        document.querySelectorAll('.article-filter-item').forEach(el=> {

            if (handle == 'all') {
                el.style.display = 'block'
            } else {
                if (el.dataset.articleBlog == handle) {
                    el.style.display = 'block'
                } else {
                    el.style.display = 'none'
                }
            }

        })
    })
})